import helperUtilities 	from 'shared/mixins/helper-utilities';

const selector = '[data-advanced-milestones-bottom-section]';

const timelineAdvancedBottomSection = function(el, app) {

  const $el = $(el);

  const init = function() {
    initListeners();
  }

  const initListeners = function() {
    app.on('milestoneActive', onMileStoneActive);
  }

  // Listen for when milestone indicator is clicked
  // TODO: pass template names in event.
  const onMileStoneActive = function(ev) {
    if(!ev[0]) {
      console.error("MilestoneActive event not passed");
      return;
    }
    const clickedIndicator = ev[0];
    const templateSelector = ev[1];

    // hide all if coming back to this on second click etc
    const allTabs = document.querySelectorAll(templateSelector);

    for(var i = 0; i > allTabs.length; i++) {
      //$(allTabs[i]).css("visibility", "hidden");
      $(allTabs[i]).addClass("Ge-Hidden");
    }

    // Find and present the corrent tab
    const tabToShow = document.querySelector('[data-js-advanced-tab-content="'+clickedIndicator+'"]');
    $(tabToShow).removeClass("Ge-Hidden");
    // alert(1);
    //tabToShow.style.visibility = "visible";

    // resize flickity if we have offvancas
    app.trigger('resizeFlickity');
  }

  return {
    init: init()
  };
}


timelineAdvancedBottomSection.selector = selector;

export default timelineAdvancedBottomSection;
